
export default class initFooter {
  constructor() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    this.collapsersFooter = document.querySelectorAll('.js-footer-collapser');
    Array.prototype.forEach.call(this.collapsersFooter, (collapserFooter) =>
        collapserFooter.addEventListener("click", this.toggleCollapser.bind(this))
    );
  }
  toggleCollapser(event) {

    if(this.isMobile){
      event.preventDefault();
      const el = event.target.nextElementSibling;
      el.classList.toggle('open');
      event.target.classList.toggle('open')
    }

}
}